<template>
	<div>
		<div v-if="!isMobile && categoryList.length > 1 && subjectId">
			<div class="category" :class="{left:!websiteInfo.isArea && !websiteInfo.desc}" :style="{color:category.txtColor}">
				<div v-if="category.name" class="btn" :class="{active:!categoryId}" :style="{background:category.bgColor}" @click="categoryFilter('')">
					<div class="icon-box">
						<img class="icon" :src="category.icon" :style="{filter:`drop-shadow(0 18px ${category.txtColor})`}">
					</div>
					<div class="name">{{ category.name }}</div>
				</div>
				<div v-for="item in categoryList" :key="item.id" class="btn" :class="{active:categoryId == item.id }" :style="{background:category.bgColor}" @click="categoryFilter(item.id)">
					<div class="icon-box">
						<img class="icon" :src="item.iconPreview" :style="{filter:`drop-shadow(0 18px ${category.txtColor})`}">
					</div>
					<div class="name">{{ item.name }}</div>
				</div>
			</div>
		</div>

		<div v-if="isMobile && (websiteInfo.isArea || categoryList.length > 1) && subjectId" class="m-page-side">
			<div v-if="websiteInfo.isArea" class="item" @click="$emit('showArea')">
				<div class="icon-box" style="background:#69a79d">
					<img class="icon" src="https://vybbasevr.vyb.cn/67c72d26_c5f4_4b24_ab5a_b1c7e2affd4a1644284653375">
				</div>
				<div class="label">区域</div>
			</div>
			<template v-if="categoryList.length > 1">
				<div v-if="category.name" class="item" :class="{active:categoryId == '' }" @click="categoryFilter('')">
					<div class="icon-box" :style="{background:category.bgColor}">
						<div class="icon" :style="{backgroundImage:`url(${category.icon})`}"></div>
					</div>
					<div class="label">{{ category.name }}</div>
				</div>
				<div v-for="item in categoryList" :key="item.id" class="item" :class="{active:categoryId == item.id }" @click="categoryFilter(item.id)">
					<div class="icon-box" :style="{background:item.color}">
						<div class="icon" :class="{fit:item.mapType == 2}" :style="{backgroundImage:`url(${item.iconPreview})`}"></div>
					</div>
					<div class="label">{{ item.alias }}</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import configPage from "@/assets/js/configPage";
	export default {

		data() {
			return {
				subjectId:this.$route.params.subjectId,
				category: {},
				categoryId: '',
				categoryList: [],
				boundaryPolygon: null,//区域多边形
			}
		},

		computed: {
			websiteInfo() {
				return this.$store.state.user.websiteInfo || {}
			}
		},

		created() {
			this.getCategory();
			this.getCategoryList();
		},

		methods: {
			async getCategory() {
				try {
					let res = await this.api.option.get({name: 'category', subjectId: this.$route.params.subjectId});
					this.category = res.data || configPage.category;
				} catch (e) {
					console.error(e)
				}
			},

			async getCategoryList() {
				try {
					let res = await this.api.category.lists({subjectId: this.$route.params.subjectId});
					this.categoryList = res.data;
				} catch (e) {
					console.error(e)
				}
			},

			//切换分类
			categoryFilter(categoryId) {
				this.categoryId = categoryId;
				this.$emit('filter', categoryId)
			},

		}
	}
</script>

<style scoped>
	.category {
		position: absolute;
		left: 240px;
		top: 100px;
		z-index: 100;
		display: flex;
		align-items: center;
		color: #fff;
	}

	.category.left {
		left: 20px;
	}

	.category .btn {
		cursor: pointer;
		margin-left: 15px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 15px;
		min-width: 110px;
		border-radius: 4px;
		background: #54877b;
	}

	.category .btn:first-child {
		margin-left: 0;
	}

	.category .btn:hover, .category .btn.active {
		opacity: 0.8;
	}

	.category .icon-box {
		margin-right: 10px;
		height: 18px;
		overflow: hidden;
		position: relative;
	}

	.category .icon {
		height: 18px;
		display: block;
		filter: drop-shadow(0 18px #fff);
		transform: translateY(-100%);
	}

	.category .name {
		font-size: 16px;
		letter-spacing: 1px;
	}

	.m-page-side {
		position: absolute;
		top: 10px;
		right: 10px;
		background: #fff;
		border-radius: 4px;
		overflow: hidden;
		z-index: 100;
		width: 50px;
		padding: 5px 0;
		box-shadow: 1px 1px 10px 1px #999;
	}

	.m-page-side .item {
		padding: 5px 0;
	}

	.m-page-side .item.active {
		background: #f1f1f1;
	}

	.m-page-side .icon-box {
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 100%;
		margin: 0 auto 5px auto;
	}

	.m-page-side .icon {
		width: 12px;
		height: 12px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center center;
	}

  .m-page-side .icon.fit{
    width:20px;
    height:20px;
  }

	.m-page-side .label {
		text-align: center;
		font-size: 12px;
		transform: scale(0.9) translateZ(0);
	}

</style>
